import * as types from './types';
import {
  STUDENT_IMAGE_STATUS_DISPLAY_IMAGE,
  STUDENT_IMAGE_STATUS_DISPLAY_DROPZONE,
} from 'Common/Constants/';

export const studentInfoInitialState = {
  loading: false,
  error: null,
  studentImage: null,
  imageStatus: STUDENT_IMAGE_STATUS_DISPLAY_DROPZONE,
};

export default (state = studentInfoInitialState, { type, payload }) => {
  switch (type) {
    case types.ACCOUNT_SETUP_STUDENT_IMAGE_SET_STATUS:
      return { ...state, imageStatus: payload };

    case types.ACCOUNT_SETUP_STUDENT_IMAGE_SET_IMAGE:
      return {
        ...state,
        studentImage: payload,
        imageStatus: STUDENT_IMAGE_STATUS_DISPLAY_IMAGE,
      };

    case types.ACCOUNT_SETUP_STUDENT_IMAGE_CLEAR_IMAGE:
      return {
        ...state,
        studentImage: null,
        imageStatus: studentInfoInitialState.imageStatus,
      };

    case types.ACCOUNT_SETUP_STUDENT_IMAGE_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.ACCOUNT_SETUP_STUDENT_IMAGE_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/studentinfo/reducer.js